import appConfig from '../../../functions/config.json';

export const FirebaseConfig = appConfig.firebaseWeb;
